export function formatMessageTime(value: Date | string | undefined | null): string {
  const raw = value instanceof Date ? value : value ? new Date(value as string) : null;
  if (!raw || Number.isNaN(raw.getTime())) {
    return '';
  }
  const mins = Math.floor((Date.now() - raw.getTime()) / 60000);
  if (mins < 1) {
    return 'ตอนนี้';
  }
  if (mins < 60) {
    return `${mins} น..`;
  }
  const hours = Math.floor(mins / 60);
  if (hours < 24) {
    return `${hours} ชม.`;
  }
  return raw.toLocaleDateString('th-TH', {day: 'numeric', month: 'short'});
}
